function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import zhCN from '@okee-uikit/react-locale';
import LoadingIcon from '../common/loading';
export var DEFAULT_CONFIG = {
  prefixCls: 'byted',
  locale: zhCN,
  popoverArrowOffset: 10,
  table: {
    size: {
      sm: {
        group: 39,
        head: 39,
        row: 39
      },
      md: {
        group: 49,
        head: 49,
        row: 49
      },
      lg: {
        group: 49,
        head: 49,
        row: 65
      },
      xl: {
        group: 49,
        head: 49,
        row: 113
      }
    }
  },
  componentSizeMap: {
    xs: {
      height: 26
    },
    sm: {
      height: 30
    },
    md: {
      height: 34
    },
    lg: {
      height: 38
    },
    xl: {
      height: 42
    }
  },
  loadingIcon: LoadingIcon
};
export var CONFIG = _objectSpread({}, DEFAULT_CONFIG);
export var ConfigContext = React.createContext(CONFIG);
export var ConfigProvider = ConfigContext.Provider;
export var getConfig = function getConfig() {
  return CONFIG;
};
export var setConfig = function setConfig(config) {
  CONFIG = config;
};